import React, { useEffect, useState } from 'react';

/**
 * Small build-version badge — shown on the Login page so a tester / MD can
 * confirm at a glance which AAB is actually installed. Reads the native
 * version via @capacitor/app on Android/iOS; falls back to a build-time
 * constant on web.
 *
 * Bump REACT_APP_BUILD_VERSION at the same time as android/app/build.gradle
 * versionName so the web shell + AAB always agree.
 */
const WEB_BUILD = process.env.REACT_APP_BUILD_VERSION || '1.0.20';

export default function AppBuildBadge() {
  const [version, setVersion] = useState(WEB_BUILD);
  const [build, setBuild] = useState(null);
  const [platform, setPlatform] = useState('web');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // Lazy-import so the web bundle doesn't pull native modules.
        const { Capacitor } = await import('@capacitor/core');
        if (cancelled) return;
        setPlatform(Capacitor.getPlatform() || 'web');
        if (Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
          const { App } = await import('@capacitor/app');
          const info = await App.getInfo();
          if (cancelled) return;
          if (info?.version) setVersion(info.version);
          if (info?.build) setBuild(info.build);
        }
      } catch {
        // Non-Capacitor environment (web) — keep build-time fallback.
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const label = build ? `v${version} (${build})` : `v${version}`;
  return (
    <p
      data-testid="app-build-badge"
      className="mt-3 text-[10px] tracking-wide text-slate-400"
    >
      ELR Industries ERP · {label} · {platform}
    </p>
  );
}
